// Vuex module — Panel Pantau Stok di Pusat (P26_0035 FR-10).
//
// Halaman /offline-stores/pos-stock. Endpointnya di routes/routes/unionweb.php grup
// `/pos-stock`, dijaga auth:api + access (modul `posstock_*`). Baca saja: tidak ada aksi
// tulis, dan jangan menambahkannya — stok toko diturunkan nfposbe dari baris pergerakan.
import $axios from "../../api";
import FileSaver from "file-saver";

const PREFIX = "unionweb/pos-stock";

const emptyPage = () => ({ data: [], total: 0, per_page: 20, from: 0, to: 0 });

const state = () => ({
  isLoading: false,
  list: emptyPage(),
  page: 1,
});

const mutations = {
  SET_LOADING(s, v) {
    s.isLoading = v;
  },
  SET_LIST(s, v) {
    s.list = v || emptyPage();
  },
  SET_PAGE(s, v) {
    s.page = v;
  },
};

const actions = {
  async getList({ commit, state, rootState, dispatch }, query = "") {
    commit("SET_LOADING", true);

    try {
      const res = await $axios.get(
        `${PREFIX}/list?page=${state.page}&view=${rootState.Main.view}${query}`
      );
      commit("SET_LIST", res.data?.data?.stocks);
      return res.data;
    } catch (error) {
      commit("SET_LIST", null);
      dispatch("Main/globalSweetAlert", error.response || { message: "Unknown error" }, { root: true });
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  // Detail satu toko × barang. Tidak disimpan di state: isinya milik satu halaman, dan
  // menaruhnya di store membuat detail barang sebelumnya sempat terlihat.
  async getDetail({ dispatch }, query) {
    try {
      const res = await $axios.get(`${PREFIX}/detail?${query}`);
      return res.data?.data;
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response || { message: "Unknown error" }, { root: true });
      throw error;
    }
  },

  async getStores() {
    const res = await $axios.get(`${PREFIX}/stores`);
    return res.data?.data?.stores || [];
  },

  async getSuppliers(_ctx, tab) {
    const res = await $axios.get(`${PREFIX}/suppliers?tab=${tab}`);
    return res.data?.data?.suppliers || [];
  },

  async exportExcel({ dispatch }, { query, tab }) {
    try {
      const res = await $axios.get(`${PREFIX}/export?${query}`, { responseType: "blob" });
      FileSaver.saveAs(res.data, `stok-${tab}.xlsx`);
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response || { message: "Export gagal" }, { root: true });
      throw error;
    }
  },
};

export default { namespaced: true, state, mutations, actions };
